<template>
  <div>
    <div class="inline-group">
      <q-input ref="qInput" type="text" v-model="inputVal" class="bs bs-q-input bs-q-input-default"
             :disable="disable" :readonly="readonly" :error="error" :placeholder="placeholder"
             :min="min" :max="max" :maxlength="maxLength" :auth-force="true"
             @keydown="onKeydown" @keydown.enter="onUpdate" @input="onInput"
             :style="{ width: isBtnView ? 'calc(100% - 35px)' : '100%' }"
      ></q-input>
    </div>

    <div class="contents-option-con-btn">
      <div class="block-group"><!-- class="block-group"은 세로 정렬 / class="inline-group"은 가로 정렬 -->
        <ul class="block-group-ul"><!-- class="block-group-ul"은 세로 정렬 목록이 많을때 쓰입니다 -->
          <li class="pad0">
            <q-btn :auth-force="true"
                   color="primary"
                   outline="outline"
                   :disable="disable"
                   class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line"
                   @click="onUpdate"
                   v-show="isBtnView"
            >
              <q-icon class="bs-q-btn-icon bs-q-btn-icon-add-sm"/>
            </q-btn>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'filter-input',
    props: {
      type: { // 'text', 'number', 'ip'
        type: String,
        default: 'text'
      },
      disable: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      isBtnView: {
        type: Boolean,
        default: false
      },
      error: {
        type: Boolean,
        default: false
      },
      cidr: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: _.noop()
      },
      min: {
        type: [String, Number],
        default: _.noop()
      },
      max: {
        type: [String, Number],
        default: _.noop()
      },
      maxLength: {
        type: [String, Number],
        default: 1000
      },
      step: {
        type: [String, Number],
        default: 1
      },
      value: {
        type: [String, Number],
        default: 0
      },
      isNetMask: {
        type: Boolean,
        default: true
      },
      isRangeMultiUse: {
        type: Boolean,
        default: true
      },
      isAnyIpUse: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        self: this,
        inputVal: 0
      }
    },
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    methods: {
      getInputDataArr (arrVal) {
        const param = []
        _.forEach(arrVal, (value) => {
          const valueTxt = _.filter(param, (str) => {
            return str === value
          })
          if (valueTxt.length === 0) {
            param.push(value)
          }
        })

        return param
      },
      onInput (val) {
        // 입력된 값이 있고, 타입이 숫자인 경우
        if (val !== '' && (this.type === 'number')) {
          // 한글 제거
          const removeHangul = this.type === 'number' ? val.replace(/[^0-9><=\-]/gi, '') : String(Number(val.replace(/[^0-9]/gi, '')))

          // 입력이 불가능한 문자열 추가
          this.$refs.qInput.$data.model = removeHangul

          // 내부 모델 추가
          this.inputVal = removeHangul
        }

        this.$emit('input', this.inputVal)
      },
      onKeydown (e) {
        if (!e.ctrlKey) { // 컨트롤 키
          if (this.type === 'number') {
            e = this.onKeydownNumber(e)
          } else if (this.type === 'port') {
            e = this.onKeydownPort(e)
          } else if (this.type.indexOf('ip') > -1) {
            e = this.onKeydownIp(e)
          } else if (this.type === 'mac') {
            e = this.onKeydownIp(e)
          }
        }
        this.$emit('keydown', e)
      },
      onKeydownNumber (e) { // type === number
        const key = e.key
        const regex = /[0-9><=\-]/
        if (key !== '-' && key.length <= 1 && !regex.test(key)) {
          e.returnValue = false
          // IE / 파이어폭스 이벤트 차단
          e.preventDefault()
        }
        return e
      },
      onKeydownPort (e) { // type === port
        const key = e.key
        const regex = /[0-9><=\-]/
        if (key !== '-' && key.length <= 1 && !regex.test(key)) {
          e.returnValue = false
          // IE / 파이어폭스 이벤트 차단
          e.preventDefault()
        }
        return e
      },
      onKeydownIp (e) {
        const key = e.key
        let regex = /[0-9a-fA-F.:]/

        if (this.type === 'ip') {
          if (this.isAnyIpUse) {
            regex = /(any|Any|ANY|[0-9a-fA-F.:anyANY])/
          } else {
            regex = /[0-9a-fA-F.:]/
          }
        } else if (this.type === 'ipv4') {
          if (this.isAnyIpUse) {
            regex = /(any|Any|ANY|[0-9.anyANY])/
          } else {
            regex = /[0-9.]/
          }
        } else if (this.type === 'ipv6') {
          if (this.isAnyIpUse) {
            regex = /(any|Any|ANY|[0-9a-fA-F:anyANY])/
          } else {
            regex = /[0-9a-fA-Z:]/
          }
        }
        if (this.isNetMask && this.isRangeMultiUse) { // NetMask 사용시
          if (key !== '-' && key !== '/' && key.length <= 1 && !regex.test(key)) {
            e.returnValue = false
            // IE / 파이어폭스 이벤트 차단
            e.preventDefault()
          }
        } else if (!this.isRangeMultiUse) { // 범위 지정 미사용
          if (key.length <= 1 && !regex.test(key)) {
            e.returnValue = false
            // IE / 파이어폭스 이벤트 차단
            e.preventDefault()
          }
        } else {
          if (key !== '-' && key.length <= 1 && !regex.test(key)) {
            e.returnValue = false
            // IE / 파이어폭스 이벤트 차단
            e.preventDefault()
          }
        }
        return e
      },
      onPaste (event) {
        const pasteText = event.clipboardData.getData('text/plain')
        if (this.type === 'number') {
          const numberRegex = /^[0-9]*$/
          if (!numberRegex.test(pasteText)) {
            event.returnValue = false
            // IE / 파이어폭스 이벤트 차단
            event.preventDefault()
          }
        } else if (this.type.indexOf('ip') > -1 || this.type === 'mac') {
          const regex = (this.type.indexOf('ip') > -1) ? /^[0-9a-fA-F.*:]*$/ : /^[0-9a-fA-F*:]*$/
          if (!regex.test(pasteText)) {
            event.returnValue = false
            // IE / 파이어폭스 이벤트 차단
            event.preventDefault()
          }
        }
      },
      onUpdate () {
        if (this.inputVal !== '') {
          this.$emit('update', this.inputVal)
        }
        this.$refs.qInput.focus()
      }
    },
    mounted () {
      this.inputVal = this.value

      const inputCons = this.$el.getElementsByTagName('input')
      _.each(inputCons, (thisCon) => {
        thisCon.addEventListener('paste', this.onPaste)
      })
    },
    watch: {
      value () {
        this.inputVal = this.value
      }
    }
  }
</script>

<style scoped>

</style>
